// @flow

import React, { Component } from "react";
import { Field } from "formik";

type $Props = {
  token: string,
  isPageForceV2Captcha: boolean,
};

class Captcha extends Component<$Props> {
  render() {
    const { token, isPageForceV2Captcha } = this.props;
    // v2 fallback will generate it's own form value after manual recaptcha is complete, so only render if we have a v3 token.
    return (
      <>
        {token && (
          <Field
            type="hidden"
            value={token}
            name="g-recaptcha-response"
            id="g-recaptcha-response"
          />
        )}
        <Field
          type="hidden"
          value={isPageForceV2Captcha}
          name="is-v2-recaptcha"
          id="is-v2-recaptcha"
        />
        <div id="recaptcha-v2-dom" />
      </>
    );
  }
}

export default Captcha;
